export enum LanguageCode {
  koKR = "ko-KR",
  enUS = "en-US",
  zhCN = "zh-CN",
  zhHK = "zh-HK",
  viVN = "vi-VN",
  jaJP = "ja-JP",
  mnMN = "mn-MN",
  thTH = "th-TH",
}

export const LanguageNameMap: Record<string, string> = {
  "ko-KR": "Korean",
  "en-US": "English",
  "zh-CN": "Chinese (Simplified)",
  "zh-HK": "Chinese (Traditional)",
  "vi-VN": "Vietnamese",
  "ja-JP": "Japanese",
  "mn-MN": "Mongolian",
  "th-TH": "Thai",
};

export const NativeLanguageNameMap: { code: LanguageCode; label: string, isLong?: boolean }[] = [
  { code: LanguageCode.koKR, label: "한국어", isLong: true },
  { code: LanguageCode.enUS, label: "English", isLong: true },
  { code: LanguageCode.zhCN, label: "中文(简体)" },
  { code: LanguageCode.zhHK, label: "中文(繁體)" },
  { code: LanguageCode.viVN, label: "Tiếng Việt", isLong: true },
  { code: LanguageCode.jaJP, label: "日本語", isLong: true },
  { code: LanguageCode.mnMN, label: "Монгол", isLong: true },
  { code: LanguageCode.thTH, label: "ภาษาไทย", isLong: true },
];